import { Box, Button, Modal, TextField, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import Header from "../../components/Header";
import ProjectApi from "../../services/api/projects";
import { useEffect } from "react";

function ProjectForm({ formData, open, handleClose }) {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isEdit, setIsEdit] = useState(false);

  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const preventCloseBackdrop = (props) => (
    <div {...props} style={{ pointerEvents: "none" }} />
  );

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: checkoutSchema,

    onSubmit: async (values, { resetForm }) => {
      if (isEdit) {
        editProject(values);
      } else {
        createProject(values);
      }

      resetForm();
    },
  });

  useEffect(() => {
    if (formData) {
      formik.setValues({
        ...formData,
      });

      setIsEdit(true);
    } else {
      formik.setValues({
        ...initialValues,
      });
      setIsEdit(false);
    }
  }, [formData]);

  const createProject = async (values) => {
    const response = await ProjectApi().create(values);

    console.log("New project created:", response);
    handleClose();
  };

  const editProject = async (values) => {
    const response = await ProjectApi().edit(formData.id, values);

    console.log("Project updated successfully:", response);
    handleClose();
  };

  const modalBody = (
    <Box
      sx={{
        width: "30%",
        bgcolor: "background.paper",
        padding: "15px",
        borderRadius: "8px",
      }}
    >
      <Header title="Project Details" />

      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Name"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="name"
            value={formik.values.name}
            inputProps={{ maxLength: 100 }}
            error={!!formik.touched.name && !!formik.errors.name}
            helperText={formik.touched.name && formik.errors.name}
            sx={{ gridColumn: "span 4" }}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Description"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="description"
            value={formik.values.description}
            inputProps={{ maxLength: 200 }}
            error={!!formik.touched.description && !!formik.errors.description}
            helperText={formik.touched.description && formik.errors.description}
            sx={{ gridColumn: "span 4" }}
          />

          <Box display="flex" alignItems="center" justifyContent="end" gap={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{
                border: "1px solid var(--color-secondary-200)",

                "&:hover": {
                  backgroundColor: "var(--color-secondary-100)",
                  border: "1px solid var(--color-secondary-100)",
                  color: "var(--color-secondary-400)",
                },
              }}
            >
              Close
            </Button>
            <Button type="submit" variant="contained">
              {isEdit ? "Update Project" : "Create New Project"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={modalStyle}
      //   BackdropComponent={preventCloseBackdrop}
    >
      {modalBody}
    </Modal>
  );
}

const checkoutSchema = yup.object().shape({
  name: yup
    .string()
    .required("required")
    .max(100, "Maximum characters limit exceeds"),
  description: yup
    .string()
    .required("required")
    .max(200, "Maximum characters limit exceeds."),
});

const initialValues = {
  name: "",
  description: "",
};

export default ProjectForm;
